var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-page"},[_c('div',{staticClass:"p-container"},[_c('div',{staticClass:"greetings"},[_vm._v("Hi！"+_vm._s(_vm.userInfo.display_name)+"，欢迎使用。")]),_c('div',{staticClass:"cards"},_vm._l((_vm.homeCards),function(item){return _c('SspHomeCard',_vm._b({key:item.key,staticClass:"cards-item"},'SspHomeCard',item,false))}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }